let envConfig;
if (process.env.NODE_ENV === 'production') {
  //正式环境配置
  envConfig = {
    interfaceSuperCode: 'https://interface.app315.net',
    SuperCode: 'https://interface.app315.net',
    Agriculture: 'https://api.s315.net', //'https://www.kf315.net', //
    AndroidPC: 'https://aio.s315.net', //'/androidpcAPI', //
    microPageBaseUrl: 'https://cjm.app315.net/Module/WeixinManage/MicroPageShow.aspx',
    generatorQR: 'https://cjm.app315.net/Ashx/CodeGenerate.ashx?data=',
    claimsUrl: 'https://ncp2.cjm.so/claims.aspx?code=', //保险理赔页面
    claimsScheduleUrl: 'https://ncp2.cjm.so/ConsumerCSchedule.aspx?code=', //理赔进程页面
    productOverdueUrl: 'https://ncp2.cjm.so/productOverdue.html', //产品过期提示页面
    H5Url: 'https://ncp2.cjm.so/index.aspx?code=',
    PackH5Url: 'http://wap.hengshan.app315.net/midpage.html?code=',
    specialCorpClaimConfig: {
      zhongNing: {
        corpID: '14141',
        claimsUrl: 'http://wap.zn.app315.net/claims.aspx?code='
      }, //中宁
      hengShan: {
        corpID: '14309',
        claimsUrl: 'http://wap.hengshan.app315.net/claims/claims.aspx?code='
      }, //横山
      daWa: {
        corpID: '11285'
      } //大洼金社裕农
    }
  };
} else {
  //开发和测试环境配置
  envConfig = {
    interfaceSuperCode: 'https://interface.kf315.net',
    SuperCode: 'https://www.kf315.net/interface',
    Agriculture: 'https://www.kf315.net/agricultureAPI', //'https://www.kf315.net', //
    AndroidPC: 'https://aio.kf315.net', //'/androidpcAPI', //
    microPageBaseUrl: 'https://app315.kf315.net/Module/WeixinManage/MicroPageShow.aspx',
    generatorQR: 'https://app315.kf315.net/Ashx/CodeGenerate.ashx?data=',
    claimsUrl: 'https://www.kf315.net/nywap2/claims.aspx?code=', //保险理赔页面
    claimsScheduleUrl: 'https://www.kf315.net/nywap2/ConsumerCSchedule.aspx?code=', //理赔进程页面
    productOverdueUrl: 'https://www.kf315.net/nywap2/productOverdue.html', //产品过期提示页面
    H5Url: 'https://www.kf315.net/nywap2/index.aspx?code=',
    PackH5Url: 'https://www.kf315.net/HengShangH5/midpage.html?code=',
    specialCorpClaimConfig: {
      zhongNing: {
        corpID: '40509',
        claimsUrl: 'https://www.kf315.net/zhongning/claims.aspx?code='
      }, //中宁
      hengShan: {
        corpID: '40226',
        claimsUrl: 'https://www.kf315.net/HengShangH5/claims/claims.aspx?code='
      }, //横山
      daWa: {
        corpID: '10054'
      } //大洼金社裕农
    }
  };
}

export default envConfig;



// WEBPACK FOOTER //
// ./src/config/env.js